export default "__VITE_ASSET__Ce6J9Z7A__"